/*
* (C) Behaviour Interactive Inc. - All Rights Reserved
* Unauthorized copying of this file, via any medium, is strictly prohibited
* This file is proprietary and confidential
*/

import React from 'react';
import { motion } from 'framer-motion';
import { ProviderName } from '../../../account/providers/ProviderEnum';
import { getProviderLogo } from '../../../account/providers/ProviderLogo';

interface Props {
  provider: ProviderName;
  cta: () => void;
  className?: string;
}

export function ProviderButton({ provider, cta, className }: Props): JSX.Element {
  return (
    <button
      type='button'
      onClick={() => cta()}
      aria-label={provider}
      className={`btn ${className}`}
      data-cy={`${provider}-btn`}
    >
      <motion.img
        layoutId={`${provider}-preferred-provider`}
        src={getProviderLogo(provider)}
        alt={`${provider}-img`}
        className='provider-btn--img'
      />
    </button>
  );
}
